export function getTenantFromSubdomain(): string {
  const hostParts = window.location.host.split(".");
  return hostParts[0];
}
